import React, {useEffect} from 'react';
import {Alert, Flex, Tag} from "antd";
import IntlMessage, {IntlMessageText} from "../../../../../components/IntlMessage/IntlMessage";
import {useDispatch, useSelector} from "react-redux";
import {getUserByToken} from "../../../../../store/slices/userSlice";
import {clrs} from "../../../../../constants/colors";
import MyText from "../../../../../components/UI/Text/MyText";
import {Link, useNavigate} from "react-router-dom";
import BlockLoading from "../../../../../components/LoadingComponents/BlockLoading";

const StudentHomePage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {user, isLoading} = useSelector(state => state.user);

    useEffect(() => {
        if (user === null) {
            dispatch(getUserByToken());
        }
    }, []);

    function formatPhoneNumber(phone) {
        if (!phone || phone.length !== 11) return phone;

        return `+7 ${phone.slice(1, 4)} ${phone.slice(4, 7)} ${phone.slice(7)}`;
    }

    return (
        <Flex style={{width: "100%"}} align={"flex-start"} justify={"flex-start"} vertical gap={20}>
            <BlockLoading style={{width: "100%"}} isLoading={isLoading}/>
            {!user?.profile?.isFullFilled &&
                <Alert
                    style={{
                        width: "100%"
                    }}
                    type={"info"}
                    showIcon
                    message={<strong><IntlMessage id={'formPage.instruction.warning'}/></strong>}
                    description={
                        <Flex vertical gap={10}>
                            <p><IntlMessage id={'needToFillProfile'}/> <Link
                                style={{textDecoration: "underline"}} target={"_blank"}
                                to={'/p/settings'}><IntlMessage
                                id={'settings'}/></Link></p>
                        </Flex>
                    }
                />
            }

            <Flex style={{
                width: "100%",
                position: "relative",
                padding: 20,
                border: `1px solid ${clrs.whiter2}`,
                borderRadius: 10,
                backgroundColor: clrs.white
            }} justify={"space-between"} align={"center"}>
                <Flex vertical gap={10}>
                    <MyText black size={"big"}>{user.profile.fullName}</MyText>
                    <Flex vertical gap={4}>
                        <MyText medium size={"small"}
                                style={{color: clrs.whiterBlacker}}>{user.profile.email}</MyText>
                        <MyText medium size={"small"}
                                style={{color: clrs.whiterBlacker}}>{formatPhoneNumber(user.profile.telNumber)}</MyText>
                        <MyText medium style={{color: clrs.whiterBlacker}}
                                size={"small"}>{user.profile.birthDay && IntlMessageText.getText({id: "birthDay"}) + ": " + new Date(user.profile.birthDay).toLocaleDateString('kk-KZ')}</MyText>
                    </Flex>
                </Flex>
                <Tag style={{padding: 6, borderRadius: 20, fontWeight: 600}} bordered={false} color={"green"}>
                    <IntlMessage id={user.role.roleName}/>
                </Tag>
            </Flex>

            {/* ТУТ НАДО СДЕЛАТЬ */}
            <Flex style={{
                width: "100%",
                position: "relative",
                padding: 20,
                border: `1px solid ${clrs.whiter2}`,
                borderRadius: 10,
                background: "linear-gradient(90deg, rgba(74,105,255,1) 0%, rgba(37,168,247,1) 100%)",
                color: clrs.white
            }} justify={"center"} align={"flex-start"} vertical gap={20}>
                <MyText black size={"big"}><IntlMessage id={"tg.dayQuote"}/></MyText>
                <MyText italic size={"default"}>“The more that you read, the more things you will know, the more that
                    you learn, the more places you’ll go.”</MyText>
                <MyText style={{alignSelf: "flex-end"}} size={"default"}>- Dr. Seuss</MyText>
            </Flex>
        </Flex>
    );
};

export default StudentHomePage;